




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  name: "quickchangeform",
  components: { StandartModal },
})
export default class QuickChangeForm extends Vue {
  @Prop({ type: String, default: null }) id!: string;
  @Prop({ type: String, default: "" }) lang!: string;
  @Prop({ type: String, default: "" }) oldName!: string | number;
  @Prop({ type: String, default: "quickChange" }) modal!: string;

  name: string | number = "";

  onSubmit(event?: Event): void {
    event?.preventDefault();
    this.$emit("quickChangeElement", this.id, this.lang, this.name);
    this.$bvModal.hide(this.modal);
  }

  @Watch("oldName")
  updateName(): void {
    this.name = this.oldName;
  }
}
